import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'izy-download-confirmation-dialog',
  imports: [
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    // MatDialogClose,
    MatButtonModule,
    MatIconModule,
  ],
  templateUrl: './download-confirmation-dialog.component.html',
  styleUrl: './download-confirmation-dialog.component.scss',
})
export class DownloadConfirmationDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<DownloadConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      documentType: string;
      invoiceId: number;
      invoiceName: string;
      companyName: string;
      text: string;
    }
  ) {}

  downloadPdf(): void {
    this.dialogRef.close({ download: true });
  }

  sendEmail(): void {
    this.dialogRef.close({ sendEmail: true });
  }

  closeDialog(): void {
    this.dialogRef.close({ download: false });
  }
}
